var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPdf = function SvgPdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "pdf_svg__a",
    d: "M0 0h17.571v20.5H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.214 1.75)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "pdf_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pdf_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.572 14.218H12c.403 0 .732.33.732.732a.73.73 0 0 1-.732.733H5.572a.73.73 0 0 1-.733-.733c0-.402.33-.732.733-.732m.197-4.73a.738.738 0 0 1 1.04-.029l1.245 1.179V5.55a.73.73 0 0 1 .732-.733.73.73 0 0 1 .732.733v5.088l1.244-1.179a.739.739 0 0 1 1.04.03.73.73 0 0 1-.03 1.032l-2.481 2.35a.748.748 0 0 1-1.025-.015l-2.467-2.335a.73.73 0 0 1-.03-1.032zM0 2.197v16.108C0 19.512.988 20.5 2.196 20.5h13.179a2.203 2.203 0 0 0 2.196-2.196V8.66c0-.585-.227-1.142-.644-1.552L10.462.644A2.164 2.164 0 0 0 8.91 0H2.196A2.203 2.203 0 0 0 0 2.196z",
    mask: "url(#pdf_svg__b)"
  })))));
};
export default SvgPdf;